"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const api_1 = require("@react-google-maps/api");
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../decorators/withStore"));
const MapConsent_1 = __importDefault(require("../Other/MapConsent"));
const Wrapper = styled_components_1.default.div `
  background-color: #777777;
  height: 92vh;
  z-index: 11;
  perspective: 1px;
  width: 100vw;
  color: #fff;
`;
const MapWrapper = styled_components_1.default.div `
  height: 100%;
`;
const Map = ({ activeItem, baseUrl }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const location = (0, react_router_dom_1.useLocation)();
    const [isFirstRender, setIsFirstRender] = (0, react_1.useState)(true);
    const [mapsGloballyEnabled, enableMapsGlobally] = (0, react_1.useState)(false);
    const [thisMapIsEnabled, setThisMapIsEnabled] = (0, react_1.useState)(false);
    const { isLoaded } = (0, api_1.useJsApiLoader)({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY || '',
        libraries: ['geometry', 'drawing', 'places'],
    });
    (0, react_1.useEffect)(() => {
        setIsFirstRender(false);
        if (process.env.PLATFORM === 'webapp' && window.usercentrics && window.usercentrics.getConsents()) {
            const mapsConsent = window.usercentrics
                .getConsents()
                .find(consent => consent.name === 'Google Maps' || consent.id === 'S1pcEj_jZX');
            const mapConsentIsActive = mapsConsent && mapsConsent.consent && mapsConsent.consent.status === true;
            if (mapConsentIsActive) {
                enableMapsGlobally(true);
                return;
            }
        }
        else {
            enableMapsGlobally(true);
        }
        if (!activeItem.type && process.env.PLATFORM === 'ds') {
            history.push({
                pathname: `${baseUrl}/overview`,
                search: location.search,
            });
        }
    }, [activeItem.type, baseUrl, history, location.search]);
    if (isFirstRender) {
        return react_1.default.createElement(Wrapper, null);
    }
    return (react_1.default.createElement(Wrapper, null, mapsGloballyEnabled || thisMapIsEnabled ? (react_1.default.createElement(MapWrapper, null, isLoaded && (react_1.default.createElement(api_1.GoogleMap, { mapContainerStyle: { height: '100%', width: '100%' }, center: {
            lat: activeItem.content.lat,
            lng: activeItem.content.lng,
        }, zoom: 15 },
        react_1.default.createElement(api_1.Marker, { position: {
                lat: activeItem.content.lat,
                lng: activeItem.content.lng,
            } }))))) : (react_1.default.createElement(MapConsent_1.default, { enableMapsGlobally: () => {
            if (window.usercentrics) {
                const mapConsent = window.usercentrics.getConsents().find(consent => consent.name === 'Google Maps');
                if (mapConsent) {
                    window.usercentrics.updateConsents([{ templateId: mapConsent.id, status: true }]);
                }
            }
            enableMapsGlobally(true);
        }, setThisMapIsEnabled: () => {
            setThisMapIsEnabled(true);
        } }))));
};
const mapStoreToProps = store => ({
    activeItem: store.getValue('activeItem'),
    baseUrl: store.getValue('baseUrl'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(Map);
